"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InfoCircle = _interopRequireDefault(require("@paprika/icon/lib/InfoCircle"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _Help = _interopRequireWildcard(require("./Help.styles"));

var propTypes = {
  children: _propTypes["default"].node.isRequired,

  /** Aria text for information button to trigger help popover. */
  triggerA11yText: _propTypes["default"].string
};
var defaultProps = {
  triggerA11yText: null
};

var _StyledPopover = (0, _styledComponents["default"])(_popover["default"]).withConfig({
  displayName: "Help___StyledPopover",
  componentId: "sc-1ux7oa3-0"
})(["", ""], _Help["default"]);

var _StyledInfoCircleIcon = (0, _styledComponents["default"])(_InfoCircle["default"]).withConfig({
  displayName: "Help___StyledInfoCircleIcon",
  componentId: "sc-1ux7oa3-1"
})(["", ""], _Help.iconStyles);

function Help(props) {
  var children = props.children,
      triggerA11yText = props.triggerA11yText,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "triggerA11yText"]);
  var I18n = (0, _useI18n["default"])();
  return /*#__PURE__*/_react["default"].createElement(_StyledPopover, (0, _extends2["default"])({
    align: "bottom",
    "data-pka-anchor": "form-element.help"
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_Help.StyledTrigger, {
    a11yText: triggerA11yText || I18n.t("formElement.aria_info_circle")
  }, /*#__PURE__*/_react["default"].createElement(_StyledInfoCircleIcon, {
    "aria-hidden": true,
    type: "exclamation-circle"
  })), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, null, children)), /*#__PURE__*/_react["default"].createElement(_popover["default"].Tip, null));
}

Help.displayName = "FormElement.Help";
Help.propTypes = propTypes;
Help.defaultProps = defaultProps;
var _default = Help;
exports["default"] = _default;
//# sourceMappingURL=Help.js.map